/**
 * @param {string} name
 * @param {HTMLElement|Document} element
 * @param {CustomEventInit} [options]
 */
const dispatchEvent = (name, element, options = {}) => {
  element.dispatchEvent(
    new CustomEvent(name, {
      bubbles: true,
      ...options,
    })
  );
};

export default dispatchEvent;
